import styled from 'styled-components'

export const Container = styled.div`
  position: relative;

  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column;
  flex-direction: column;
  overflow: hidden;
`

export const ContainerTable = styled.div`
  position: relative;
  padding: 16px 12px;
  width: 100%;
  display: flex;
  flex-flow: column;
  flex: 1 1 auto;
  overflow: hidden;

  background-color: ${({ theme }) => theme.zds.colors.neutral1000};
  border-radius: ${({ theme }) => theme.zds.border.radius100};
`

export const TableFiltersHeader = styled.div`
  position: relative;
  margin-bottom: 15px;
  flex: 0 1 auto;

  display: grid;
  grid-template-columns: 135px auto;
  grid-column-gap: 10px;
`

export const PaginationContainer = styled.div`
  position: relative;
  width: 100%;
  margin-top: 32px;
  flex: 0 1 auto;

  display: flex;
  flex-wrap: wrap-reverse;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
`

export const ResultsPerPageContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  font: normal normal normal 14px/17px Inter;
  letter-spacing: 0px;
  color: ${props => props.theme.colors.color6b7786};
`
